import { render } from "./SelectTyres.vue?vue&type=template&id=d4f4d41a"
import script from "./SelectTyres.vue?vue&type=script&lang=js"
export * from "./SelectTyres.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__